import React from 'react';
import useAuth from '../hooks/context/useAuth';
import { Navigate, Outlet } from 'react-router';
import { Routes } from './Router';

export default function AuthGuard() {
  const { isLoggedIn } = useAuth();

  return isLoggedIn ? <Outlet /> : <Navigate to={`/${Routes.Login}`} />;
}
